<dgx-panel-list
  [collectionName]="i18n.LearningSearch_Groups"
  [isLoading]="isLoading"
  [totalNumItems]="totalNumItems"
  [maxDisplayedItems]="5"
  [linkData]="linkData"
>
  <ul>
    <li
      *ngFor="let item of items; trackBy: trackByFn"
      data-dgat="search-groups-bbe"
    >
      <!--dgx-list-item is our item template that provides ng-content placeholders for a left-justified icon and a right-justified button (or whatever you want to stick there).
    Here, we're just providing the icon and "follow" button--the custom parts. The item layout, title and description are all pre-packaged in the list item component and reused everywhere-->
      <dgx-list-item [item]="item">
        <!--Item icon-->
        <ng-container icon>
          <df-icon
            [a11yText]="getA11yText(item.model.privacyLevel)"
            [icon]="getIconType(item.model.privacyLevel)"
            class="color-ebony-a61 round bg-color-ebony-a08 privacy-icon"
          ></df-icon>
        </ng-container>
      </dgx-list-item>
    </li>
  </ul>
</dgx-panel-list>

<dgx-search-sidebar-no-results
  *ngIf="showNoResults"
  [collectionName]="i18n.LearningSearch_Groups"
></dgx-search-sidebar-no-results>

<dgx-search-sidebar-error
  *ngIf="showError"
  [collectionName]="i18n.LearningSearch_Groups"
></dgx-search-sidebar-error>
